import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { GlobalLoaderService } from '../global-loader.service';

@Component({
    selector: 'app-global-loader',
    templateUrl: './global-loader.component.html',
    styleUrls: ['./global-loader.component.scss'],
    animations: fuseAnimations,
})
export class GlobalLoaderComponent implements OnInit {
    isLoading$: Observable<boolean>;
    message$: Observable<string>;
    constructor(private globalLoaderService: GlobalLoaderService) {}

    ngOnInit() {
        this.isLoading$ = this.globalLoaderService.isLoading$;
        this.message$ = this.globalLoaderService.message$;
    }
}
